const route = {
    path: '/generator',
    meta: { authClass: 'protected' },
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "generator" */ '../../components/views/generator/generator.vue'),
            }
        },
    ],
}

module.exports = route;